import { render, staticRenderFns } from "./MangelControl.vue?vue&type=template&id=0a45a92e&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./MangelControl.vue?vue&type=script&lang=js&"
export * from "./MangelControl.vue?vue&type=script&lang=js&"
import style0 from "./MangelControl.vue?vue&type=style&index=0&id=0a45a92e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a45a92e",
  null
  
)

export default component.exports